export default "__VITE_ASSET__543b2a10__"